/* src/app/invoice/setup/invoice-setup-update-dialog/invoice-setup-update-dialog.component.scss */
form ::ng-deep {
  min-width: 25em;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
form ::ng-deep h2 {
  font-size: 1em;
  padding: 0;
  margin: 0;
  padding-top: 0.5em;
  padding-bottom: 1em;
  text-decoration: underline;
}
form ::ng-deep span.p-float-label {
  padding-bottom: 0.5em;
  margin-top: 1em;
  width: 100%;
}
form ::ng-deep span.p-float-label .p-dropdown,
form ::ng-deep span.p-float-label .p-inputtext,
form ::ng-deep span.p-float-label .p-calendar {
  width: 100%;
}
form ::ng-deep span.p-float-label > p-tristatecheckbox + label,
form ::ng-deep span.p-float-label > p-checkbox + label {
  top: 0 !important;
}
::ng-deep .popup-alert .p-message {
  max-width: -moz-fit-content;
  max-width: fit-content;
}
/*# sourceMappingURL=invoice-setup-update-dialog.component.css.map */
